import { importDependency } from 'core-components/helpers'
import { IAppStoreRemoteReducers } from 'src/core/components/app/models/IAppStore'

import omniReducer from './omniSlice'

export const omniProjectReducer = {
  omni: omniReducer,
}

export const omnicomRemoteReducers: IAppStoreRemoteReducers[] = []
